import { BarChart3 } from 'lucide-react'

interface EmptyChartProps {
  message?: string
  className?: string
}

export function EmptyChart({ message = 'No data available', className }: EmptyChartProps) {
  return (
    <div className={`flex flex-col items-center justify-center h-[300px] text-muted-foreground ${className}`}>
      <BarChart3 className="h-12 w-12 mb-2" />
      <p className="text-sm">{message}</p>
    </div>
  )
} 